import { useCallback } from "react"

import { selectActiveCurrency } from "stores/currency/currencySlice"
import { useAppSelector } from "stores/hooks"

const useCurrency = () => {
  const res = useAppSelector(selectActiveCurrency)

  const formatter = useCallback(
    (minimumFractionDigits = 0, maximumFractionDigits = 2) => {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits,
        maximumFractionDigits,
        currencySign: "standard",
        style: "currency",
        currency: res.code || "USD",
      })
    },
    [res.code],
  )

  return { ...res, formatter }
}

export default useCurrency
